namespace GeniuzPOS.Purchase {
    export interface ReportPurTaxLongForm {
        Lineitemno: Serenity.IntegerEditor;
        DocDate: Serenity.DateEditor;
        TaxInvoiceDate: Serenity.DateEditor;
        TaxInvoiceNo: Serenity.StringEditor;
        SupplName: Serenity.StringEditor;
        SupplTaxId: Serenity.StringEditor;
        NetAmt: Serenity.DecimalEditor;
        VatAmt: Serenity.DecimalEditor;
        TotalAmt: Serenity.DecimalEditor;
        RefDocNo1: Serenity.StringEditor;
    }

    export class ReportPurTaxLongForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.ReportPurTaxLong';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReportPurTaxLongForm.init)  {
                ReportPurTaxLongForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateEditor;
                var w2 = s.StringEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(ReportPurTaxLongForm, [
                    'Lineitemno', w0,
                    'DocDate', w1,
                    'TaxInvoiceDate', w1,
                    'TaxInvoiceNo', w2,
                    'SupplName', w2,
                    'SupplTaxId', w2,
                    'NetAmt', w3,
                    'VatAmt', w3,
                    'TotalAmt', w3,
                    'RefDocNo1', w2
                ]);
            }
        }
    }
}
